<template>
  <AlertDismissable header="Error" variant="danger" icon="exclamation-triangle" :message="message" @dismissed='$emit("dismissed")'/>
</template>

<script>
  import AlertDismissable from '@/components/alerts/Dismissable'

  export default {
    name: 'AlertError',
    components: {
      AlertDismissable
    },
    props: {
      message: String
    },
    data() {
      return {
      }
    },
  }
</script>
